import request from '@/api/axios'
import { apiList as api } from './apiList'

// 获取工具箱分页列表
export function getToolList(data) {
  return request({
    url: api.excersise.getToolList, // /tpi/drawing/page
    method: 'post',
    data,
  })
}

// 新增和修改工具
export function saveOrUpdateTool(data) {
  return request({
    url: api.excersise.saveOrUpdateTool, // /tpi/drawing/saveOrUpdate
    method: 'PUT',
    data,
  })
}

/**
 * 资源筛选字典
 * @param {*} code
 * @returns
 */
export function getDictItem(code) {
  return request({
    url: api.excersise.getDictItem + code,
    method: 'get',
  })
}
/**
 * 获取教材
 * @param {*} data
 * @returns
 */
export function getTutorial(data) {
  return request({
    url: api.excersise.getTutorial,
    method: 'post',
    data,
  })
}
/**
 * 获取单元
 * @param {*} code
 * @returns
 */
export function getDirByTutorial(code) {
  return request({
    url: api.excersise.getDirByTutorial + code,
    method: 'get',
  })
}
